import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedToken = localStorage.getItem('authToken');
    return storedToken ? { token: storedToken } : null;
  });
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('authToken');
    setUser(null);
    navigate('/signin');
  };

  useEffect(() => {
    // Add a response interceptor for all axios requests
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // Check if error is due to token expiration
        if (error.response?.status === 401 && 
            (error.response?.data?.detail === "Token expired" || 
             error.response?.data?.detail === "Invalid token")) {
          console.log('Token expired, logging out...');
          logout();
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptor on unmount
    return () => axios.interceptors.response.eject(interceptor);
  }, [navigate]);

  return (
    <UserContext.Provider value={{ user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);